import { t } from '@base/utils/helpers';
import { container } from 'tsyringe';
import { CreateMessageType, IGameProvider } from '../game/model/interfaces';
import Codes from '../socket/codes';

const types = [
  { type: 'PRESSED_START', value: 'pressed_start', regex: /^Pressed 'Start'$/ },
  { type: 'PRESSED_CONTINUE', value: 'pressed_continue', regex: /^Pressed 'Continue'$/ },
  { type: 'I_RESIGN', value: 'i_resign', regex: /^I resign!$/ },
  { type: 'PLEASE_MOVE', value: 'please_move', regex: /^Please move!$/ },
  {
    type: 'I_RECONNECTED',
    value: 'i_reconnected',
    regex: /^Reconnection completed. (\d+) reconnections left. Time remaining for reconnections (\d+) min.(\d+) sec.$/,
  },
  {
    type: 'I_RECONNECTED_LAST',
    value: 'i_reconnected_disallowed',
    regex: /^Reconnection completed. Next reconnection disallowed. Reason: (.+)$/,
  },
  { type: 'GREETINGS', value: 'greetings_message', regex: /^Hi ([^,]+), welcome to GameColony ([^!]+)!$/m },
  { type: 'RANDOM_DEALER', value: 'random_dealer', regex: /^Random selection of the dealer$/ },
  { type: 'LADDER_GAME_STARTED', value: 'ladder_game_started', regex: /^Ladder game started$/ },
  { type: 'LADDER_POSITION', value: 'ladder_position', regex: /^Your current Ladder ranking:(.+)$/ },
  { type: 'LADDER_WINNER', value: 'ladder_game_winner', regex: /^(.+) won in ladder game$/ },
  {
    type: 'OPPONENTS_USE_THE_SAME_COMPUTER',
    value: 'opponents_use_the_same_computer',
    regex: /^Opponents use the same computer. Game changed to non-rated.$/,
  },
  { type: 'SCORE', value: 'chat_message_score', regex: /^Score:\s*(\d+)\s*-\s*(\d+)\s*$/ },
];

export class Message {
  type: number;
  pid?: number;
  tid?: number;
  text: string;
  color: string;
  echo = false;
  // Для контроля своих сообщений, которые возвращаются эхом
  recipientName?: string | undefined;
  recipientId = -1;
  recipientTableId = -1;
  // Для сообщения о приглашении
  invite = -1;

  playerName: string | undefined;
  senderName: string | undefined;
  moneyPlayer?: number;
  muted?: number;

  constructor(data: CreateMessageType) {
    this.type = data.type;
    this.pid = data.pid;
    this.tid = data.tid;
    this.text = this.getText(data.text, data.type);
    this.color = data.color ? data.color.replace('0x', '') : '';
    this.recipientName = data.recipientName;
  }

  private getText(text: string, type: number) {
    let t = text;

    switch (type) {
      case Codes.MessageTypes.GOD:
      case Codes.MessageTypes.INFO:
      case Codes.MessageTypes.TABLE:
        t = this.localize(text);
        break;
    }

    return t;
  }

  private localize(s: string): string {
    let result = s;
    let type: string | undefined;
    let match: RegExpMatchArray | null = null;

    let res;
    for (let t of types) {
      match = s.match(t.regex)
      if (match) {
        res = t;
        break;
      }
    }

    if (res) {
      result = res.value;
      type = res.type;
    } else {
      console.log('[LocalizableMessage]', 'unknown type for string:', s);
      return result;
    }

    if (match) {
      switch (type) {
        case 'GREETINGS':
          const gameProvider: IGameProvider = container.resolve('gameProvider');
          return t(result, match[1], t(gameProvider.APP_NAME));
        case 'I_RECONNECTED':
          return t(result, match[1], match[2], match[3]);
        case 'I_RECONNECTED_LAST':
        case 'LADDER_POSITION':
        case 'LADDER_WINNER':
          return t(result, match[1]);
        case 'SCORE':
          return t(result, match[1], match[2]);
      }
    }
    return t(result);
  }
}
